import { useMemo } from 'react';
import { ListType } from 'testDrive/types';
import { AnimatedImage, BackButton, Button, Modal, Typography } from 'ui';
import Bolt2 from 'ui/components/newIcons/Bolt2';
import s from './ServiceableOemPopup.module.scss';

interface ServiceableOemPopupProps {
  show: boolean;
  onClose: () => void;
  list: ListType[];
  handleClick: (list) => void;
  isLoading: boolean;
  totalCars: number;
}

const ServiceableOemPopup = ({
  show,
  onClose,
  list,
  handleClick,
  isLoading,
  totalCars,
}: ServiceableOemPopupProps) => {
  const text = useMemo(() => {
    const obj: any = {};
    if (totalCars > 1) {
      obj.title = `Test drive unavailable for ${totalCars} cars in your region`;
    } else {
      obj.title = `Test drive unavailable for 1 car
      in your region`;
    }
    if (list?.length > 1) {
      obj.subtitle = `Continue booking for these ${list?.length} models?`;
    } else {
      obj.subtitle = 'Continue booking for this model?';
    }
    return obj;
  }, [list, totalCars]);

  return (
    <Modal
      show={show}
      head={{ show: true, onClose: () => onClose() }}
      rootStyle={{ zIndex: 2 }}
    >
      <div className={s.root}>
        <BackButton
          type="hidden"
          onBack={() => {
            onClose();
          }}
        />
        <div className={s.text}>
          <Typography
            label={text?.title}
            variant="h3"
            style={{ marginBottom: '8px' }}
          />
          <Typography
            label={text?.subtitle}
            variant="base_big_r"
            color="text_subheading"
          />
        </div>
        <div className={s.list}>
          {list?.map((item, idx) => (
            <div key={`${idx}$^()`} className={s.card}>
              <AnimatedImage
                src={item?.metaData?.bannerImage}
                className={s.image}
              />
              <div className={s.textStack}>
                <Typography
                  variant="body_big_b"
                  className={s.textLine}
                  label={item?.displayModelName}
                  style={{ marginBottom: '2px' }}
                />
                <Typography
                  variant="body_r"
                  color="text_label"
                  className={s.textLine}
                  label={`₹${item?.displayPrice} onwards`}
                  style={{ marginBottom: '4px' }}
                />
                <Typography
                  variant="body_r"
                  color="text_label"
                  className={s.textLine}
                  label={item?.specText}
                />
              </div>
            </div>
          ))}
        </div>
        <div className={s.strip}>
          <Bolt2 width={20} height={20} />
          <Typography
            label="Book test drive and get one year of FREE petrol"
            variant="small_m"
            color="text_caption"
          />
        </div>
        <Button
          onClick={() => {
            handleClick(list);
          }}
          label="Continue booking"
          fullwidth
          isDisabled={isLoading}
          isLoading={isLoading}
        />
      </div>
    </Modal>
  );
};

export default ServiceableOemPopup;
